<app-loader [isBusy]="isBusy">
    <ng-template>
        <div class="modal-header">
            <h4 class="modal-title">{{ title }}</h4>
            @if (summary) {
                <div class="summary-badges ml-3">
                    <span class="badge badge-light border mr-1">
                        {{ summary.totalInFile }}&nbsp;{{ 'Total' | translate }}
                    </span>
                    <span class="badge badge-success mr-1">
                        {{ summary.successCount }}&nbsp;{{ 'Successful' | translate }}
                    </span>
                    <span class="badge badge-warning mr-1">
                        {{ summary.warningCount }}&nbsp;{{ 'Warning' | translate }}
                    </span>
                    <span class="badge badge-danger">{{ summary.failedCount }}&nbsp;{{ 'Failed' | translate }}</span>
                </div>
            }
            <button class="close" type="button" aria-label="Close" (click)="close()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            @if (message) {
                <p class="mb-3">{{ message }}</p>
            }

            @if (shouldShowSubtitle) {
                <div class="row">
                    <div class="col">
                        <h6>{{ subtitle }}:</h6>
                        <hr />
                    </div>
                </div>
            }
            @if (rows?.length) {
                <div class="filter-row">
                    <div class="row align-items-center">
                        <div class="col-3">
                            <form-dropdown
                                labelText="{{ 'Severity' | translate }}"
                                [codeListValues]="severityCodeListValues"
                                [(ngModel)]="filterSeverity"
                                (valueChange)="applyFilter()"></form-dropdown>
                        </div>
                        <div class="col-9">
                            <form-textbox
                                labelText="{{ 'Search' | translate }}"
                                [(ngModel)]="searchText"
                                (ngModelChange)="applyFilter()"></form-textbox>
                        </div>
                    </div>
                </div>
            }
            @if (filteredRows?.length) {
                <div class="errors-container">
                    <table class="table table-stripped table-bordered">
                        <tr>
                            <th style="width: 36px"></th>
                            <th style="width: 140px">
                                {{ columnHeader }}
                            </th>
                            <th>{{ valueHeader }}</th>
                        </tr>
                        @for (item of filteredRows; track item) {
                            <tr>
                                <td class="text-center">
                                    @if (item.severity) {
                                        <fa-icon
                                            [icon]="getSeverityIcon(item.severity)"
                                            [class]="getSeverityClass(item.severity)"
                                            [title]="item.severity"></fa-icon>
                                    }
                                </td>
                                <td>{{ item.firstValue | translate }}</td>
                                <td>{{ item.secondValue | translate }}</td>
                            </tr>
                        }
                    </table>
                </div>
            } @else {
                @if (noResults) {
                    <div class="text-center py-4">
                        <fa-icon class="mb-2" size="2x" [icon]="['fas', 'search']"></fa-icon>
                        <p>{{ noRowsText }}</p>
                    </div>
                }
                @if (!noResults && !hasRows) {
                    <div class="text-center text-muted py-4">
                        <fa-icon class="text-success mb-2" size="2x" [icon]="['fas', 'check-circle']"></fa-icon>
                        <p>{{ 'All records imported successfully with no errors.' | translate }}</p>
                    </div>
                }
            }
        </div>
        <div class="modal-footer">
            <button class="btn btn-sm btn-secondary" type="button" (click)="close()">
                {{ closeButtonName || ('OK' | translate) }}
            </button>
        </div>
    </ng-template>
</app-loader>
